<template>
    <div class="dl-call">
        <div class="dl-wrap">
            <div class="center">
                <div class="item client">
                    <a :href="'https://images.huoxingy.com/callClient/'+curStoreId+'.zip'">客户端下载</a>
                </div>
                <!-- <div class="item service" style="margin-right:20px;">
                    <a :href="'https://images.huoxingy.com/xpClient/'+curStoreId+'.zip'">服务端(XP)下载</a>
                </div> -->
                <div class="item service">
                    <a :href="'https://images.huoxingy.com/service/'+curStoreId+'.zip'">服务端(Win7/Win10)下载</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props:['curStoreId', 'pageSize'],
        data(){
            return {

            }
        },
        mounted () {
            
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
    @import "./dlCall.scss";
</style>



// WEBPACK FOOTER //
// dlCall.vue?946586b0